import React from 'react';
import { motion } from 'framer-motion';
import { CreditCardIcon, LandmarkIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage } from '../data/offer';
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="bg-stage relative isolate overflow-hidden pb-16 pt-12 sm:pb-20 sm:pt-16" data-id="element-131" data-mp="1297esbauxdd0">
      <div className="absolute right-0 top-0 -z-10 h-80 w-80 border-b border-l border-gold/25" data-id="element-132" data-mp="xanra6gm7tij" />
      <div className="mx-auto max-w-6xl px-4 text-center" data-id="element-133" data-mp="sb1bpqdbe16k">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-gold/40 bg-petrolDark px-4 py-2 text-xs font-extrabold uppercase tracking-[.14em] text-gold" data-id="element-134" data-mp="s9giq56neqat">
          <LandmarkIcon className="h-4 w-4" data-id="element-135" data-mp="3j7zcjaz8recz" /> Megapack Museología Listo™
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-4xl text-balance text-4xl font-extrabold leading-[1.06] text-white sm:text-6xl md:text-7xl" data-id="element-136" data-mp="3o85cdefo0765">
          Del diagnóstico a la acción.<br data-id="element-137" data-mp="30gq5r9guv3p3" />
          <span className="text-gold" data-id="element-138" data-mp="30g6m9obk478y">Todo resuelto.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto my-4 max-w-2xl sm:my-6" data-id="element-139" data-mp="35a2fyeksf7yb">
          <img src={productImage} alt="Megapack Museología Listo: nueve tomos y cinco bonos para museos y patrimonio en Argentina" className="mx-auto w-full drop-shadow-[0_24px_40px_rgba(6,16,32,.5)]" data-id="element-140" data-mp="2hix0w1mo8jp2" />
        </motion.div>

        <div className="flex flex-wrap justify-center gap-2 text-xs font-bold text-onDark" data-id="element-141" data-mp="nbbc4wdi0748">
          {['Acceso inmediato', 'Hecho para Argentina', 'Pago seguro'].map(item => <span key={item} className="rounded-full border border-lineDark bg-petrolDark px-3 py-2" data-id="element-142" data-mp="ia5j0xfxehu6">
              {item}
            </span>)}
        </div>

        <div className="mt-7" data-id="element-143" data-mp="1azkufobi6cqm">
          <Button onClick={scrollToPricing} arrow data-id="element-144" data-mp="1ayt7f1vz1nby">QUIERO MI MEGAPACK AHORA</Button>
        </div>

        <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-mutedDark" data-id="element-145" data-mp="15zq2dhfzrh3z">
          <span className="inline-flex items-center gap-1.5" data-id="element-146" data-mp="114kg2hiog0fd"><ShieldCheckIcon className="h-4 w-4 text-gold" data-id="element-147" data-mp="x0crckc7ykh5" /> Garantía 7 días</span>
          <span className="inline-flex items-center gap-1.5" data-id="element-148" data-mp="3lt76ct9j5vvb"><LockIcon className="h-4 w-4 text-gold" data-id="element-149" data-mp="3lqugltxj6h7p" /> Pago seguro</span>
          <span className="inline-flex items-center gap-1.5" data-id="element-150" data-mp="3hqkckmtau0vh"><CreditCardIcon className="h-4 w-4 text-gold" data-id="element-151" data-mp="1x9b6f48dr7e5" /> Mercado Pago</span>
        </div>

        <p className="mt-5 inline-flex items-center gap-2 text-xs font-semibold text-mutedDark" data-id="element-152" data-mp="21awbw4il4jeb">
          <ZapIcon className="h-4 w-4 text-gold" data-id="element-153" data-mp="218k0693f759p" /> Para docentes, estudiantes y profesionales de museos y patrimonio de toda Argentina
        </p>
      </div>
    </section>;
}